import { Dayjs } from 'dayjs';
import { SnackbarSeverityType } from '../../../enums';

export type ModalMode = 'add' | 'edit' | null;

export type StaffAttendanceStatus =
  | 'All'
  | 'PRESENT'
  | 'ABSENT'
  | 'LEAVE'
  | 'HALF_DAY_PRESENT';

export enum AttendanceSource {
  ADMIN = 'ADMIN',
  SELF = 'SELF',
  TRACKER = 'TRACKER',
  CRON = 'CRON'
}

export interface SchoolShift {
  id?: string;
  school: string;
  shiftName: string;
  startTime: string;
  endTime: string;
  gracePeriodInMinutes: number;
  minimumHoursForHalfDay: string;
  minimumHoursForFullDay: string;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface StaffAttendanceView {
  userId: string;
  name?: string;
  profile?: string;
  role?: string;
  email?: string;
  displayRole?: string;
  source?: AttendanceSource;
  status?: StaffAttendanceStatus;
  school?: string;
  attendanceDate?: Dayjs | null;
  markedAs: StaffAttendanceStatus;
  remarks?: string;
  shiftDetails?: SchoolShift;
  punchInTime?: string;
  punchOutTime?: string;
  markedAsLate?: boolean;
  memberCode?: string;
}

export interface StaffAttendanceProps {
  searchDate: Dayjs | null;
  staffAttendanceData: StaffAttendanceView[];
  onEdit: (params: StaffAttendanceView) => void;
  loading: boolean;
}

export interface StaffAttendanceModalProps {
  open: boolean;
  onClose: () => void;
  selectedStaffAttendanceData?: StaffAttendanceView | null;
  mode: ModalMode;
  showToast: (message: string, severity: SnackbarSeverityType) => void;
  fetchStaffAttendanceData: (displayToast: boolean) => Promise<void>;
  searchDate: Dayjs | null;
}
